import {
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  Select,
  Space,
} from "antd";
import AddingTable from "components/Tables/AddingTable";
import TextArea from "antd/es/input/TextArea";
import {
  SAFE_TYPES,
  SYDE_TYPES,
  Trans_TYPES,
} from "../../../constants/accountsConstants";
import WrappingModal from "../../../components/Modals/WrappingModal";
import { useGetProductsQuery } from "../../../redux/Service/productsApi";
import { useGetStoresQuery } from "../../../redux/Service/storesApi";
import { useGetCostCentersQuery } from "../../../redux/Service/costCenter";
import { useGetSellersQuery } from "../../../redux/Service/sellersApi";
import { useGetCurrenciesQuery } from "../../../redux/Service/currenciesApi";
import { useGetTaxesQuery } from "../../../redux/Service/TaxesApi";

interface Props {
  form: any;
  isEditing: boolean;
  isModalOpen: boolean;
  handleOk: (values: any) => void;
  handleCancel: () => void;
  initialValues?: any;
  loading: boolean;
  subData: any[];
  setSubData: any;
  branches: any[];
  vendors: any[];
  cashSubData: any[];
  setCashSubData: any;
  boxes: any[];
  banks: any[];
}

const FormModal = ({
  form,
  isEditing,
  isModalOpen,
  handleOk,
  handleCancel,
  initialValues,
  loading,
  subData,
  setSubData,
  vendors,
  branches,
  cashSubData,
  setCashSubData,
  boxes,
  banks,
}: Props) => {
  const { data: productsData, isLoading } = useGetProductsQuery(undefined);
  const products = productsData?.ResponseObject ?? [];

  const { data: storiesData, isLoading: isStoriesLoading } =
    useGetStoresQuery(undefined);
  const stories = storiesData?.ResponseObject ?? [];

  const {
    data: costCentersData,
    isLoading: iscostCentersLoading,
    isError: iscostCentersError,
  } = useGetCostCentersQuery(undefined);

  const costCenters = costCentersData?.ResponseObject ?? [];

  const {
    data: sellersData,
    isLoading: issellersLoading,
    isError: issellersError,
  } = useGetSellersQuery(undefined);

  const sellers = sellersData?.ResponseObject ?? [];

  const {
    data: currenciesData,
    isLoading: isCurrenciesLoading,
    isError: isCurrenciesError,
  } = useGetCurrenciesQuery(undefined);

  const currencies = currenciesData?.ResponseObject ?? [];

  const { data: taxesData } = useGetTaxesQuery(undefined);
  const taxes = taxesData?.ResponseObject ?? [];

  const productsColumns = [
    {
      title: "م",
      dataIndex: "RowNo",
      width: 20,
      editable: false,
    },
    {
      title: " المنتج",
      dataIndex: "ProductID",
      // width: 130,
      editable: true,
      inputType: "select",
      options: products.map((producct: any) => ({
        value: String(producct.ProductID),
        label: producct.Productname,
      })),
    },
    {
      title: "السعر",
      dataIndex: "ProductCost",
      // width: 120,
      editable: true,
      inputType: "number",
    },

    {
      title: "مركز التكلفه",
      dataIndex: "CostId",
      // width: 130,
      editable: true,
      inputType: "select",
      // Pass options dynamically from your accounts list:
      options: costCenters.map((center: any) => ({
        value: String(center.CostID),
        label: center.CostName,
      })),
      render: (text: string) => {
        const account = costCenters.find((a: any) => String(a.CostID) === text);
        return account ? account.CostName : text;
      },
    },
    {
      title: "ملاحظات",
      dataIndex: "Notes",
      // width: 200,
      editable: true,
      inputType: "text",
    },
  ];
  const cashesColumns = [
    {
      title: "م",
      dataIndex: "RowNo",
      width: 20,
      editable: false,
    },
    {
      title: "نوع الجهة",
      dataIndex: "SafeType",
      // width: 130,
      editable: true,
      inputType: "select",
      options: SAFE_TYPES,
    },
    {
      title: " الجهة",
      dataIndex: "SafeId",
      // width: 130,
      editable: true,
      inputType: "select",
      options: (record) =>
        record.SafeType === 0
          ? boxes.map((b) => ({ value: b.BoxID, label: b.BoxName }))
          : banks.map((b) => ({ value: b.BankID, label: b.BankName })),
    },
    {
      title: "القيمة",
      dataIndex: "Value",
      // width: 120,
      editable: true,
      inputType: "number",
    },
  ];

  const onFinish = (values: any) => {
    handleOk(values);
  };

  return (
    <WrappingModal
      form={form}
      handleCancel={handleCancel}
      loading={loading}
      isModalOpen={isModalOpen}
      title={isEditing ? "تعديل فاتورة" : "إضافة فاتورة"}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={initialValues}
        onFinish={onFinish}
      >
        {/* Data Entry Section */}
        <Space direction="vertical" className="w-full" size="large">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
            {isEditing && (
              <Form.Item name="DocID" label="كود الفاتورة">
                <InputNumber
                  placeholder="كود الفاتورة"
                  className="w-full"
                  disabled
                />
              </Form.Item>
            )}

            <Form.Item name="DueDate" label="تاريخ الاستحقاق">
              <DatePicker className="w-full" format="YYYY-MM-DD" />
            </Form.Item>

            <Form.Item name="CurrId" label="العملة">
              <Select placeholder="اختر العملة" className="w-full">
                {currencies.map((account) => (
                  <Select.Option key={account.CurrID} value={account.CurrID}>
                    {account.CurrName}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item name="SellerID" label="المندوب">
              <Select
                placeholder="المندوب"
                showSearch
                optionFilterProp="children"
                options={sellers.map((seller: any) => ({
                  value: seller.SellerID,
                  label: seller.SellerName,
                }))}
                className="w-full"
              />
            </Form.Item>

            <Form.Item name="BranchId" label="الفرع">
              <Select
                placeholder="الفرع"
                showSearch
                optionFilterProp="children"
                options={branches.map((branch: any) => ({
                  value: branch.BranchID,
                  label: branch.BranchName,
                }))}
                className="w-full"
              />
            </Form.Item>
            {/* <Form.Item name="StoreId" label="المخزن">
              <Select
                placeholder=" المخزن"
                showSearch
                optionFilterProp="children"
                options={stories.map((bal: any) => ({
                  value: bal.StoreID,
                  label: bal.StoreName,
                }))}
                className="w-full"
              />
            </Form.Item> */}
            <Form.Item name="SideType" label="نوع الجهة">
              <Select
                className="w-full"
                placeholder="اختر نوع الجهة"
                options={SYDE_TYPES}
              />
            </Form.Item>

            <Form.Item name="VendorId" label="المورد">
              <Select
                placeholder="المورد"
                showSearch
                optionFilterProp="children"
                options={vendors.map((vendor: any) => ({
                  value: vendor.VendorID,
                  label: vendor.VendorName,
                }))}
                className="w-full"
              />
            </Form.Item>
          </div>

          {/* Table Section */}
          <AddingTable
            columns={productsColumns}
            data={subData ?? []}
            setData={setSubData}
          />

          <Divider orientation="center">المدفوعات</Divider>

          <div className="flex  gap-4">
            <div className="flex-1">
              <AddingTable
                columns={cashesColumns}
                data={cashSubData ?? []}
                setData={setCashSubData}
              />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
              <Form.Item name="CurrRate" label="سعر الصرف">
                <InputNumber className="w-full" placeholder="سعر الصرف" />
              </Form.Item>

              <Form.Item name="SumTotal" label="إجمالي الفاتورة">
                <InputNumber className="w-full" placeholder="الإجمالي" />
              </Form.Item>

              <Form.Item name="DiscountP" label="نسبة الخصم (%)">
                <InputNumber className="w-full" placeholder="نسبة الخصم" />
              </Form.Item>

              <Form.Item name="DiscountValue" label="قيمة الخصم">
                <InputNumber className="w-full" placeholder="قيمة الخصم" />
              </Form.Item>

              <Form.Item name="TaxID" label="الضريبة">
                <Select placeholder="الضريبة" className="w-full">
                  {taxes.map((tax) => (
                    <Select.Option key={tax.TaxID} value={tax.TaxID}>
                      {tax.TaxName}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item name="TaxRate" label="معدل الضريبة">
                <InputNumber className="w-full" placeholder="معدل الضريبة" />
              </Form.Item>

              <Form.Item name="NetTotal" label="الإجمالي الصافي">
                <InputNumber className="w-full" placeholder="الإجمالي الصافي" />
              </Form.Item>

              <Form.Item name="NetTotalTafqit" label="الإجمالي نصاً">
                <Input className="w-full" placeholder="الإجمالي كتابة" />
              </Form.Item>

              <Form.Item name="PayType" label="طريقة الدفع">
                <Select
                  className="w-full"
                  placeholder="اختر طريقة الدفع"
                  options={[
                    { label: "نقداً", value: 0 },
                    { label: "آجل", value: 1 },
                  ]}
                />
              </Form.Item>
            </div>
          </div>

          {/* Feedback Section */}
          <Form.Item name="Notes" label="ملاحظاتك">
            <TextArea rows={4} placeholder="اكتب ملاحظاتك" />
          </Form.Item>
        </Space>
      </Form>
    </WrappingModal>
  );
};

export default FormModal;
